/**
 * Adapter: delegates IAiAdvisor port to services/geminiService.
 */
import type { CityStats, Grid, NewsItem, AIGoal } from '../../../types';
import {
  generateNewsEvent,
  generateCityGoal,
  generateCoachingTip,
  generateMissionBriefing,
} from '../../../services/geminiService';
import type { IAiAdvisor } from '../../domain/ports/IAiAdvisor';

export class GeminiAiAdvisorAdapter implements IAiAdvisor {
  async generateNews(stats: CityStats, context?: string): Promise<NewsItem> {
    const item = await generateNewsEvent(stats, context ?? null);
    if (!item) {
      throw new Error('AI news generation returned empty');
    }
    return item;
  }

  async generateGoal(stats: CityStats, grid: Grid): Promise<AIGoal> {
    const goal = await generateCityGoal(stats, grid);
    if (!goal) {
      throw new Error('AI goal generation returned empty');
    }
    return goal;
  }

  async generateCoachingTip(objective: string): Promise<string> {
    const tip = await generateCoachingTip(objective);
    return tip ?? 'System offline. Consult manual.';
  }

  async generateBriefing(stats: CityStats): Promise<string> {
    const briefing = await generateMissionBriefing(stats);
    return briefing ?? 'Briefing unavailable.';
  }
}